import React from "react";

const TONES = {
  neutral: { wrap: "bg-subtle text-inkSecondary", dot: "bg-muted" },
  brand: { wrap: "bg-brandSoft text-main", dot: "bg-main" },
  success: { wrap: "bg-successSoft text-success", dot: "bg-success" },
  warning: { wrap: "bg-warningSoft text-warning", dot: "bg-warning" },
  danger: { wrap: "bg-dangerSoft text-danger", dot: "bg-danger" },
  info: { wrap: "bg-infoSoft text-info", dot: "bg-info" },
};

const StatusBadge = ({ tone = "neutral", children, dot = false, className = "" }) => {
  const t = TONES[tone] || TONES.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-bold whitespace-nowrap ${t.wrap} ${className}`}
    >
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${t.dot}`} />}
      {children}
    </span>
  );
};

export default StatusBadge;
